import { render, staticRenderFns } from "./DesfazerEliminacao.vue?vue&type=template&id=2c5da39a"
import script from "./DesfazerEliminacao.vue?vue&type=script&lang=js"
export * from "./DesfazerEliminacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports